import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, NgForm, Validators } from '@angular/forms';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MeterReadingEmailRecibos } from 'src/app/models/meter-reading-email';
import { CommonService } from 'src/app/services/common.service';
import { VirtualOfficeService } from 'src/app/services/virtual-office.service';
import { ModalConfirmComponent } from '../modal-confirm/modal-confirm.component';

@Component({
  selector: 'app-modal-send-mail',
  templateUrl: './modal-send-mail.component.html'
})
export class ModalSendMailComponent implements OnInit {
  operationId: string;
  nextDate: string;
  imageBase64: string; 
  operationNumber:string;
  formGroup: FormGroup;
  constructor(public dialog: MatDialog, public dialogRefSendEmail: MatDialogRef<any>, private commonService: CommonService,
    private formBuilder: FormBuilder,
    private virtualOfficeService: VirtualOfficeService, @Inject(MAT_DIALOG_DATA) public data: any) {
    this.operationId = this.data.operationId,
    this.nextDate = this.data.nextDate,
    this.operationNumber = this.data.operationNumber,
    this.imageBase64 = this.data.imageBase64,
    this.operationId= this.data.operationId;
  }

  ngOnInit(): void {
    this.createForm();
  }
  createForm() {
    this.formGroup = this.formBuilder.group({     
      email: [null, [Validators.required, Validators.pattern("^[^@]+@([-\\w]+\\.)+[A-Za-z]{2,4}$")]]
    })
  }
  async sendEmail() {    
    if (this.formGroup.valid) {
      let data = new MeterReadingEmailRecibos(this.formGroup.controls.email.value, this.operationId,this.nextDate,this.operationNumber,this.imageBase64);
       let response = await this.virtualOfficeService.sendMeterReadingEmail(data);
      if (response.valid) {
        const dialogRef = this.dialog.open(ModalConfirmComponent, {
          data: {
            subject: 'El correo fue enviado correctamente',
            value: ''
          },
          width: '400px',
          autoFocus: false,
          panelClass: 'dialog-custom-2',
          disableClose: true
        });
        dialogRef.afterClosed().subscribe(result => {
          this.dialogRefSendEmail.close()
        });
      } else this.commonService.openErrorDialog([response.message])
    } else {
      if (this.formGroup.controls.email.invalid) {
        this.commonService.openErrorDialog(['Debe ingresar un correo válido.'])
      }
    }
  }
}